import { Device, SimpleSubscription, User } from "@models";
import {
  AutoAwesomeOutlined,
  BuildCircleOutlined,
  Close,
} from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { CreateDeviceUiState } from "@types";
import { useState } from "react";
import { BubbleAccordion } from "src/components/BubbleAccordion/BubbleAccordion";
import { ImportDeviceModalContent } from "src/components/DeviceCreation/modal-list-items/ImportDeviceModalContent";
import { newProductInitialState } from "src/components/DeviceCreation/modal-list-items/MyDeviceModalComponents/utils";
import { MyDeviceModalContent } from "src/components/DeviceCreation/modal-list-items/MyDeviceModalContent";
import { getOrgFromUser } from "src/utils/user";

export const DeviceCreationModal = ({
  open,
  onClose,
  subscription,
  user,
  devices,
  orgId,
  setExpandedId,
  expandedId,
}: {
  open: boolean;
  onClose: () => void;
  subscription: SimpleSubscription;
  user: User;
  devices: Device[];
  orgId: string;
  setExpandedId: (id: number) => void;
  expandedId: number;
}) => {
  const org = getOrgFromUser(user, orgId);

  const [deviceIsAiGenerated, setDeviceIsAiGenerated] =
    useState<boolean>(false);
  const [newDevice, setNewDevice] = useState<CreateDeviceUiState>(
    newProductInitialState
  );

  const setNewDeviceAndOpenPanel = (newDevice: CreateDeviceUiState) => {
    setNewDevice(newDevice);
    setDeviceIsAiGenerated(true);
    setExpandedId(1);
  };

  if (!org) {
    return null;
  }

  const handleChange =
    (id: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedId(isExpanded ? id : -1); // -1 is none expanded
    };

  // Demo devices can't be created if there is already a real device
  // const existsRealDevice = devices.some((device) => !device.isDemoDevice);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle className="flex justify-between items-center">
        <Typography component="div" variant="h6">
          Create A Device
        </Typography>
        <Close
          onClick={onClose}
          className="cursor-pointer bg-gray-200 rounded-full p-1"
        />
      </DialogTitle>
      <DialogContent>
        <BubbleAccordion
          expandedId={expandedId}
          handleChange={handleChange}
          title="Import My Device With AI"
          subtitle="Import a product from your website to get started"
          Icon={AutoAwesomeOutlined}
          id={0}
          hasShineBorder={!deviceIsAiGenerated} //remove shine when its already filled in details
        >
          <div data-testid="import-device-content">
            <ImportDeviceModalContent setDevice={setNewDeviceAndOpenPanel} />
          </div>
        </BubbleAccordion>
        <BubbleAccordion
          expandedId={expandedId}
          handleChange={handleChange}
          title="Fill In My Device"
          subtitle="Manually fill in your device details"
          Icon={BuildCircleOutlined}
          id={1}
        >
          <div data-testid="normal-device-content">
            <MyDeviceModalContent
              subscription={subscription}
              devices={devices}
              org={org}
              setNewDevice={setNewDevice}
              newDevice={newDevice}
              deviceIsAiGenerated={deviceIsAiGenerated}
            />
          </div>
        </BubbleAccordion>
        {/* {!existsRealDevice && (
          <BubbleAccordion
            expandedId={expandedId}
            handleChange={handleChange}
            title="Try A Demo Device"
            subtitle="Take a quick tour of our features"
            Icon={RocketLaunchOutlined}
            id={2}
          >
            <div data-testid="demo-device-content">
              <DemoDeviceModalContent orgId={orgId} />
            </div>
          </BubbleAccordion>
        )} */}
      </DialogContent>
    </Dialog>
  );
};
